import { defineStore } from 'pinia'
import { authApi, bandsApi } from '@/api'

// Tras reset_session en el servidor el token CSRF rota; el backend nos devuelve
// uno nuevo y lo reflejamos en el <meta> para las siguientes peticiones.
function updateCsrf(token) {
  if (!token) return
  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta) meta.content = token
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    band: null,
    bands: [], // solo el superadmin recibe la lista de grupos
    loaded: false,
  }),
  getters: {
    isAuthenticated: (state) => !!state.user,
    isAdmin: (state) => !!state.user?.admin,
    isManager: (state) => !!state.user?.manager,
    isStaff: (state) => !!state.user?.staff,
    isSuperadmin: (state) => !!state.user?.superadmin,
  },
  actions: {
    async fetchCurrentUser() {
      try {
        const { data } = await authApi.me()
        this.user = data.user
        this.band = data.band
        this.bands = data.bands || []
      } catch {
        this.user = null
        this.band = null
        this.bands = []
      } finally {
        this.loaded = true
      }
    },
    async login(credentials) {
      const { data } = await authApi.login(credentials)
      updateCsrf(data.csrf_token)
      this.user = data.user
    },
    async logout() {
      const { data } = await authApi.logout()
      updateCsrf(data?.csrf_token)
      this.user = null
      this.band = null
      this.bands = []
    },
    // Cambia el grupo activo (superadmin) y recarga la app con sus datos.
    async switchBand(id) {
      await bandsApi.switch(id)
      window.location.assign('/')
    },
    // Refleja cambios del propio perfil devueltos por la API.
    setUser(user) {
      if (user && this.user && user.id === this.user.id) this.user = user
    },
  },
})
